export const organisationConstants = {
    ORGANISATION_LOGO_GET_REQUEST: 'ORGANISATION_LOGO_GET_REQUEST',
    ORGANISATION_LOGO_GET_SUCCESS: 'ORGANISATION_LOGO_GET_SUCCESS',
    ORGANISATION_LOGO_GET_FAILURE: 'ORGANISATION_LOGO_GET_FAILURE',

    ORGANISATIONS_GET_BY_USER_REQUEST: 'ORGANISATIONS_GET_BY_USER_REQUEST',
    ORGANISATIONS_GET_BY_USER_SUCCESS: 'ORGANISATIONS_GET_BY_USER_SUCCESS',
    ORGANISATIONS_GET_BY_USER_FAILURE: 'ORGANISATIONS_GET_BY_USER_FAILURE'
};